import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import FormInput from "../controls/FormInput";
import { useTranslation } from "react-i18next";
import GoogleLogin from "../../components/auth/GoogleLoginButton";
import { useNavigate } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/20/solid";

const EmailLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [error, setError] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const { login, signup } = useAuth();
  const { t } = useTranslation();
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (isLogin) {
        await login(email, password);
        console.log(t("auth.loginSuccess"));
        navigate("/home");
      } else {
        if (password !== confirmPassword) {
          setError(t("auth.passwordsDontMatch"));
          return;
        }
        await signup(email, password, fullName);
        setError("");
        setEmail("");
        setFullName("");
        setPassword("");
        setConfirmPassword("");
        navigate("/home");
      }
    } catch (err) {
      console.log(err.message);
      if (err.message === "Email not confirmed") {
        setError(t("auth.emailNotConfirmed"));
      } else {
        setError(err.message || t("auth.errorOccurred"));
      }
    }
  };

  return (
    <div className="w-full max-w-sm space-y-4">
      {/* Ajout du bouton retour */}
      <div className="flex">
        <button
          onClick={() => {
            navigate("/home");
          }}
          className="text-primary hover:underline cursor-pointer ml-auto"
        >
          <XMarkIcon className="w-5 h-5 text-gray-500"></XMarkIcon>
        </button>
      </div>

      <h2 className="text-xl font-bold text-center">
        {isLogin ? t("auth.loginTitle") : t("auth.signupTitle")}
      </h2>
      <GoogleLogin></GoogleLogin>
      <div className="border-t stone-600 my-6"></div>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        {/* Champ Nom complet */}
        {!isLogin && (
          <FormInput
            label={t("auth.fullName")}
            name="fullName"
            value={fullName}
            onChange={(name, value) => setFullName(value)}
            placeholder={t("auth.fullNamePlaceholder")}
            required={true}
            type="text"
          />
        )}

        {/* Champ Email */}
        <FormInput
          label={t("auth.emailLabel")}
          name="email"
          value={email}
          onChange={(name, value) => setEmail(value)}
          placeholder={t("auth.emailPlaceholder")}
          required={true}
          type="email"
        />

        {/* Champ Mot de passe */}
        <FormInput
          label={t("auth.passwordLabel")}
          name="password"
          value={password}
          onChange={(name, value) => setPassword(value)}
          placeholder={t("auth.passwordPlaceholder")}
          required={true}
          type="password"
        />

        {/* Champ Confirmation de Mot de Passe */}
        {!isLogin && (
          <FormInput
            label={t("auth.confirmPassword")}
            name="confirmPassword"
            value={confirmPassword}
            onChange={(name, value) => setConfirmPassword(value)}
            placeholder="Confirmez votre mot de passe"
            required={true}
            type="password"
          />
        )}

        {/* Bouton de soumission */}
        <button
          type="submit"
          className="w-full bg-primary text-white py-2 px-4 rounded-full hover:bg-accent transition"
        >
          {isLogin ? t("auth.loginButton") : t("auth.signupButton")}
        </button>
      </form>

      {/* Lien pour basculer entre connexion et création */}
      <div className="text-sm text-gray-600 text-center">
        {isLogin ? t("auth.noAccount") : t("auth.haveAccount")}{" "}
        <span
          onClick={() => {
            setIsLogin(!isLogin);
            setError("");
            setEmail("");
            setFullName("");
            setPassword("");
          }}
          className="text-primary hover:underline cursor-pointer"
        >
          {isLogin ? t("auth.signupLink") : t("auth.loginLink")}
        </span>
      </div>
    </div>
  );
};

export default EmailLogin;
